import type { ICategoryRepository } from "../interfaces/ICategoryRepository";
import type { CategoryDto } from "../../shared/CategoryDto";

export class CategoryService {
  readonly repo: ICategoryRepository;
  constructor(repo: ICategoryRepository) {
    this.repo = repo;
  }
  getById(categoryId: number): Promise<CategoryDto | null> {
    return this.repo.getById(categoryId)
  }

  async getAllCategories() {
    return this.repo.getAll();
  }
}
